import cn from 'classnames';

import { isMobile } from '@webapp/common/lib/ua';

import Fullscreen from 'packages/common/assets/icons/fullscreen.svg';

import css from './fullscreen.css';

export const IconFullscreen: FC<{ className?: string; onClick?: (e: React.MouseEvent) => void }> = ({
    className,
    onClick,
}) => {
    return (
        <div
            className={cn(css.iconWrapper, className, { [css.iconWrapperMobile]: isMobile })}
            onClick={onClick}
            data-no-dnd='true'
        >
            <Fullscreen />
        </div>
    );
};
